/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ShipmentCostComponentRequest = {
    /**
     * Free text, max 60 chars
     */
    label: string;
    planned?: number | null;
    actual?: number | null;
    /**
     * Per-row basis override; null follows the container method (FR-4.3)
     */
    allocationBasisOverride?: ShipmentCostComponentRequest.allocationBasisOverride | null;
    /**
     * Display order; defaults to appending at the end
     */
    sortOrder?: number | null;
};
export namespace ShipmentCostComponentRequest {
    /**
     * Per-row basis override; null follows the container method (FR-4.3)
     */
    export enum allocationBasisOverride {
        VALUE = 'value',
        VOLUME = 'volume',
        WEIGHT = 'weight',
    }
}

